import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from './config/index'
import wx from 'jweixin-module'

import './assets/scss/global.scss'

import './assets/iconfont/iconfont.css'

import VueWechatTitle from 'vue-wechat-title'
// import * as fundebug from 'fundebug-javascript'
// import fundebugVue from 'fundebug-vue'

import moment from 'moment'
import {
    Button, Toast, Field, Popup, TreeSelect, Picker, Search, Image, Tab, Tabs, Overlay, Swipe, SwipeItem, Divider, Checkbox, CheckboxGroup, Collapse, CollapseItem,
    Cell, CellGroup, Form, RadioGroup, Radio,Cascader,Area,Badge
} from 'vant'
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
Vue.use(ElementUI);

// fundebug.apikey = 'ecf6ac7f6483c2faa285260c9c70374f51a313ec50b701d903815a8a948737d3'
// fundebugVue(fundebug, Vue)

Vue.config.productionTip = false

Vue.use(Button).use(Field).use(Popup).use(TreeSelect).use(Picker).use(Search).use(Image).use(Tab).use(Tabs).use(Overlay).use(Swipe).use(SwipeItem).use(Divider).use(Checkbox).use(CheckboxGroup).use(Collapse).use(CollapseItem)
Vue.use(VueWechatTitle)
Vue.use(Cell).use(CellGroup).use(Form).use(RadioGroup).use(Radio).use(Cascader).use(Area).use(Badge)

Vue.prototype.$toast = Toast
Vue.prototype.$config = config
Vue.prototype.$wx = wx
Vue.prototype.$moment = moment

Vue.config.ignoredElements = ['wx-open-launch-weapp'];

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
